import { TableBody, TableColumnContainer, TableItemTextView, TableItemView, TableView } from "components/shared";
import React from "react";
import { DisabledPrompt } from "bcms-react";
import { SVGAsset } from "res";
import { UICheckbox } from "components/ui";
import StateTaxIDTableRow from "../StateTaxIDTableRow";

import "./styles.css";

/**
 * @function StateTaxIDTable
 * @return {React.Component}
 * @exported true
 * @description This is the state tax ID main table view
 */
export default function StateTaxIDTable(props) {
  const stateTaxIDs = props.stateTaxIDs ?? [];
  const onDenyAllClick = props.onDenyAllClick ?? undefined;
  const onRowClick = props.onRowClick ?? undefined;
  const allRowsCheckboxIsSelected = props.allRowsCheckboxIsSelected === true;

  const rows = stateTaxIDs.reduce((acc, item) => {
    acc.push(
      <StateTaxIDTableRow key={ item.id } company={ item.company.name } state={ item.state }
       taxId={ item.taxID } stateTaxID={ item } onRowClick={ onRowClick } isSelected={ item.isSelected } />
    );
    return acc;
  }, []);

  return (
    <TableView className="state-tax-id-table">
      <TableColumnContainer className="state-tax-id-table-header">
        <TableItemView className="checkbox-col" >
          <UICheckbox label="" value={ allRowsCheckboxIsSelected } onChange={ onDenyAllClick }/>
        </TableItemView>
        <TableItemView lassName="company-col" >
          <span className="flex-container align-center">
            <span className="set-width">Company</span>
            <DisabledPrompt>
              <SVGAsset id="ArrowUpIcon" className="arrow-up-icon clickable" />
            </DisabledPrompt>
          </span>
        </TableItemView>
        <TableItemView lassName="state-col" >
          <span className="flex-container align-center">
            <span className="set-width">State</span>
            <DisabledPrompt>
              <SVGAsset id="SortIcon" className="sort-icon clickable" />
            </DisabledPrompt>
          </span>
        </TableItemView>
        <TableItemView lassName="tax-id-col" >
          <span className="flex-container align-center">
            <span className="set-width">Tax ID</span>
            <DisabledPrompt>
              <SVGAsset id="SortIcon" className="sort-icon clickable" />
            </DisabledPrompt>
          </span>
        </TableItemView>
        <TableItemTextView className="actions-col" />
      </TableColumnContainer>
      <TableBody>{ rows }</TableBody>
    </TableView>
  )
}
